import { gql } from '@apollo/client';

export const StopDictationByEventMutation = gql`
    mutation StopDictationByEvent($eventId: ID!) {
        stopDictationByEvent(eventId: $eventId)
    }
`;
